import { __extends } from "tslib";
export default function Widget(options) {
    function Factory(classType) {
        return /** @class */ (function (_super) {
            __extends(AbstractWidget, _super);
            function AbstractWidget() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            AbstractWidget.register = function () {
                var elements;
                if (!window.eshopWidgets) {
                    window.eshopWidgets = {}; // TODO: What happens if multiple times one widget
                }
                if (options.selector) {
                    elements = AbstractWidget.dispatchElementsBySelector(options.selector);
                }
                else {
                    elements = AbstractWidget.dispatchElements(options.name);
                }
                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                    var element = elements_1[_i];
                    var instance = new AbstractWidget();
                    instance.applyElement(element);
                    instance.applyProps();
                    instance.bindEventListeners();
                    instance.didMount();
                    window.eshopWidgets[options.name] = instance;
                }
            };
            AbstractWidget.dispatchElements = function (selector) {
                selector = '[data-vfeo="%"]'.replace('%', selector);
                return document.querySelectorAll(selector);
            };
            AbstractWidget.dispatchElementsBySelector = function (selector) {
                selector = selector;
                return document.querySelectorAll(selector);
            };
            AbstractWidget.prototype.applyElement = function (e) {
                this.element = e;
            };
            AbstractWidget.prototype.applyProps = function () {
                this.props = {};
                if (classType.propTypes) {
                    for (var propType in classType.propTypes) {
                        var propValue = this.getElement().dataset[propType];
                        if (classType.propTypes[propType].validate(propValue)) {
                            this.props[propType] = classType.propTypes[propType].parseValue(propValue);
                        }
                    }
                }
            };
            AbstractWidget.prototype.getElement = function () {
                return this.element;
            };
            AbstractWidget.prototype.bindEventListeners = function () {
                var _this = this;
                var clickableElements = this.element.querySelectorAll('[data-vfeo-click]');
                var _loop_1 = function (clickableElement) {
                    var method = clickableElement.getAttribute('data-vfeo-click');
                    var clickEvent = function (e) {
                        e.preventDefault();
                        _this.dispatch(method);
                    };
                    clickableElement.addEventListener('touchend', clickEvent);
                    clickableElement.addEventListener('click', clickEvent);
                };
                for (var _i = 0, clickableElements_1 = clickableElements; _i < clickableElements_1.length; _i++) {
                    var clickableElement = clickableElements_1[_i];
                    _loop_1(clickableElement);
                }
            };
            AbstractWidget.prototype.dispatch = function (fn) {
                var callable = Function(fn).bind(this);
                callable();
            };
            return AbstractWidget;
        }(classType));
    }
    return Factory;
}



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/core/widget/widget.ts
// module id = null
// module chunks = 